__webpack_require__.p = "/tokens-marketplace-ribbon/system-email-templates/";